import { useCallback } from 'react';

import { JumpDirection } from '@swf/components/StarsWizard/components/Navigation/Navigation';
import type { WizardContext } from '@swf/core/types/Wizard';

const usePaymentVerificationServicesData = () => ({
  jumpBackToDeposit: useCallback(async ({ data }: WizardContext) => {
    if (data?.goJump) {
      delete data?.goJump;
    }
    return {
      goJump: {
        target: '#deposit.deposit-summary',
        direction: JumpDirection.Next
      }
    };
  }, []),

  paymentVerificationSave: async ({ values: { paymentVerification } }: WizardContext) =>
    Promise.resolve({})
});

export default usePaymentVerificationServicesData;
